import { Injectable } from '@angular/core'
import { AuthService } from '../core/auth.service'
import { DatastoreEntitiesService } from './admin/datastore-entities.service'
import { ConsoleLogService } from './console-log.service'
import { DatastoreCollectionsService } from './datastore-collections.service'
import { DatastoreMessagesService } from './datastore-messages.service'
import { NetworkStatusService } from './network-status.service'
import { OfflineTransactionsService } from './offline-transactions.service'
import { WebsocketService } from './websocket.service'
import { DatastoreService } from './datastore.service'
import { HelpersService } from './helpers.service'

@Injectable({
  providedIn: 'root',
})
export class SystemSetupService {
  constructor(
    private offlineTransactionsService: OfflineTransactionsService,
    private consoleLogsServices: ConsoleLogService,
    private networkStatusService: NetworkStatusService,
    private websocketService: WebsocketService,
    private datastore: DatastoreService,
    private messageService: DatastoreMessagesService,
    private datastoreEntitiesService: DatastoreEntitiesService,
    private datastoreCollectionsService: DatastoreCollectionsService,
    private auth: AuthService,
    private helpersService: HelpersService
  ) {}

  async init() {
    // this.helpersService.googleApiLoaded()
    this.datastoreCollectionsService.clearCollections()
    // this.datastore.loadDataStore();
    // console.log('SystemSetupService:init');
    this.networkStatusService.init()
    this.offlineTransactionsService.setup()
    if (this.auth.hasRole('messageService')) {
      this.messageService.loadMessages()
      this.websocketService.setupSignalR()
    }
    if (this.auth.hasRole('admin')) {
      this.datastoreEntitiesService.loadData()
    }
    this.consoleLogsServices.setup()
  }
}
